export const RADIO_GROUP_PAYMENT_METHODS_TYPE = {
  newPaymentMethods: "NEW_PAYMENT_METHODS",
  savedPaymentMethods: "SAVED_PAYMENT_METHODS",
};
